module.exports = __webpack_public_path__ + "static/media/help_background.d14c54ea.svg";